import { render, staticRenderFns } from "./TermAxia.vue?vue&type=template&id=570c12f2"
import script from "./TermAxia.vue?vue&type=script&lang=js"
export * from "./TermAxia.vue?vue&type=script&lang=js"
import style0 from "./Term.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports